<div class="handle-upload-row" [ngClass]="{ 'has-file': hasExisting }">
  <!-- STATUS (left) -->
  @if (hasExisting) {
    <div class="status-cell" aria-hidden="true" [title]="labels.fileAttached">
      <span class="status-check">
        <mat-icon>check_circle</mat-icon>
      </span>
    </div>
  }
  @if (!hasExisting) {
    <div class="status-cell" aria-hidden="true"></div>
  }

  <!-- CONTENT (middle) -->
  <div>
    <div class="row-title">
      {{ label || currentDocument?.fileName || labels.attachDocument }} @if (isRequired) {
      <span>*</span>
    }
  </div>
  <div class="row-meta">
    @if (!hasExisting) {
      <span class="meta-chip">{{ labels.expected }}: {{ expectedType | uppercase }}</span>
    } @else {
      <span class="file-ellipsis">
        {{ labels.current }}:&nbsp;{{ currentDocument?.fileName }}
      </span>
    }
  </div>
</div>

<!-- ACTIONS (right) -->
<div class="button-group">
  @if (!hasExisting) {
    <button
      class="icon-btn"
      mat-stroked-button
      color="primary"
      (click)="onPick(fileInput)"
      [disabled]="disabled || uploading"
      [class.spinner]="uploading"
      [attr.aria-label]="'handleUpload.uploadFile' | transloco">
      <mat-icon>upload</mat-icon>
      {{ labels.upload }}
    </button>
  }

  @if (hasExisting && showDownload) {
    <button
      class="icon-btn"
      mat-icon-button
      color="primary"
      (click)="onDownload()"
      [disabled]="uploading"
      [attr.aria-label]="'handleUpload.downloadFile' | transloco">
      <mat-icon>download</mat-icon>
    </button>
  }

  @if (hasExisting) {
    <button
      class="icon-btn"
      mat-icon-button
      color="warn"
      (click)="onClear()"
      [disabled]="disabled || uploading"
      [attr.aria-label]="'handleUpload.removeFile' | transloco">
      <mat-icon>delete</mat-icon>
    </button>
  }
</div>

<!-- hidden file input -->
<input
  #fileInput
  hidden
  type="file"
  [accept]="accept"
  (click)="fileInput.value=''"
  (change)="onFileSelected($event)" />
</div>